import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { isObjectValidAndNotEmpty } from '../utils/nullChecks';
import { getLoginState, persistLogin } from '../utils/localStorage';
import { SessionData } from '../types/LogInTypes';
import { getRedirectionPathWithDestination, getSessionDataIfSessionIsValid } from '../utils/loginUtil';

const useValidateSession = (destination: string) => {
    const loginState = getLoginState();
    const history = useHistory();

    const validateSessionOrRedirect = async () => {
        const sessionData = await getSessionDataIfSessionIsValid();
        if (isObjectValidAndNotEmpty<SessionData>(sessionData)) {
            if (!isObjectValidAndNotEmpty(loginState.login)) {
                persistLogin(sessionData);
            }
            history.push(destination);
        } else {
            const redirectionPathWithDestination =
                getRedirectionPathWithDestination(destination);
            history.push(redirectionPathWithDestination);
        }
    };

    useEffect(() => {
        validateSessionOrRedirect();
    }, []);
};

export default useValidateSession;
